/**
 *
 * PortalButton
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 11-Oct-2022
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Button, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import PortalLoader from '../PortalLoader';
import style from './PortalButton.scss';

const PortalButton = (props) => {
	const intl = useIntl();

	return (
		<Grid className={style.container}>
			{props.isLoading ? (
				<PortalLoader />
			) : (
				<Button
					variant={props.variant}
					color={props.componentColor}
					disabled={props.isDisabled}
					onClick={props.onClick}
					size={props.componentSize}
					className={`${props.path ? style.withPath : ''} ${props.className}`}
					type={props.type}
					form={props.formId}>
					{props.path ? (
						<Link to={props.path}>
							{props.isTranslatedMessage ? intl.formatMessage(props.contentText) : props.contentText}
						</Link>
					) : props.isTranslatedMessage ? (
						intl.formatMessage(props.contentText)
					) : (
						props.contentText
					)}
				</Button>
			)}
		</Grid>
	);
};

PortalButton.propTypes = {
	contentText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	isTranslatedMessage: PropTypes.bool,
	variant: PropTypes.string,
	isDisabled: PropTypes.bool,
	onClick: PropTypes.func,
	isLoading: PropTypes.bool,
	componentSize: PropTypes.oneOf(['small', 'medium', 'large']),
	componentColor: PropTypes.oneOf(['primary', 'secondary']),
	className: PropTypes.string,
	type: PropTypes.string,
	formId: PropTypes.string,
	path: PropTypes.string,
};

PortalButton.defaultProps = {
	variant: 'contained',
	isDisabled: false,
	isLoading: false,
	componentSize: 'medium',
	componentColor: 'primary',
	isTranslatedMessage: true,
	className: '',
	type: '',
	formId: '',
	path: '',
};

export default PortalButton;
